import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { debounceTime, distinctUntilChanged, filter, map, Subscription } from 'rxjs';

@Component({
    selector: 'mmoga-organization-site-search',
    imports: [
        ReactiveFormsModule
    ],
    templateUrl: './organization-site-search.component.html',
    styleUrl: './organization-site-search.component.scss'
})
export class OrganizationSiteSearchComponent implements OnInit, OnDestroy {

    @Output() searchTermEvent: EventEmitter<string> = new EventEmitter<string>();

    private searchSubscription = new Subscription();

    searchTermControl = new FormControl<string>('', { nonNullable: true });

    ngOnInit(): void {
        this.searchSubscription = this.searchTermControl.valueChanges.pipe(
            debounceTime(300),
            map(term => (term || '').trim()),
            distinctUntilChanged(),
            filter(term => term.length === 0 || term.length > 2)
        ).subscribe(term => {
            this.searchTermEvent.emit(term);
        });
    }

    ngOnDestroy(): void {
        this.searchSubscription.unsubscribe();
    }
}
